import jsPDF from "jspdf";
import horeImg from "../obr/hore.png";
import doleImg from "../obr/dole.png";
import {
  nacitajPdfFonty,
} from "./pdfFonty";

const OKRAJ_X = 15;
export const INVEST_PDF_OKRAJ_X = OKRAJ_X;
const SIRKA_STRANY = 210;
const VYSKA_STRANY = 297;
const VYSKA_HLAVY = 30;
const VYSKA_PATY = 20;

export const INVEST_PDF_START_Y = 42;
export const INVEST_PDF_MAX_Y = 266;
export const INVEST_PDF_SIRKA_OBSAHU =
  SIRKA_STRANY - OKRAJ_X * 2;

const FARBA_NADPIS = [120, 102, 67];
const FARBA_TEXT = [45, 45, 45];
const FARBA_JEMNA = [110, 110, 110];
const FARBA_LINKA = [205, 196, 177];
const FARBA_PATY = [255, 255, 255];

const FARBA_PREHLAD_HLAVICKA = [248, 245, 238, ];

const FARBA_PREHLAD_SEKCIA = [
  246,
  242,
  234,
];

const FARBA_PREHLAD_RIADOK = [
  232,
  228,
  219,
];

const INVEST_PDF_PREHLAD_ROZLOZENIE =
  Object.freeze({
    padding: 4,
    vyskaNadpisu: 8,
    vyskaHlavicky: 7,
    vyskaSekcie: 6,
    vyskaRiadka: 5.2,
    sirkaPopisuJedenVariant: 92,
    sirkaPopisuDvaVarianty: 76,
  });

const FIREMNE_UDAJE = Object.freeze([
  "FinCloud s.r.o.",
  "IČO: 54394139, Kalinčiakova 33A, 831 04 Bratislava",
  "Spoločnosť je zapísaná v registri SFA NBS pod č. 269451",
]);

function hodnotaText(hodnota) {
  return String(hodnota || "").trim();
}

function pridajObrazokCover(
  pdf,
  imageData,
  x,
  y,
  cielovaSirka,
  cielovaVyska,
  zarovnanieX = "center"
) {
  const vlastnosti =
    pdf.getImageProperties(imageData);

  const povodnaSirka =
    vlastnosti.width || 1;

  const povodnaVyska =
    vlastnosti.height || 1;

  const mierka = Math.max(
    cielovaSirka / povodnaSirka,
    cielovaVyska / povodnaVyska
  );

  const sirka =
    povodnaSirka * mierka;

  const vyska =
    povodnaVyska * mierka;

  let posunX = x;

  if (zarovnanieX === "center") {
    posunX =
      x + (cielovaSirka - sirka) / 2;
  } else if (
    zarovnanieX === "right"
  ) {
    posunX =
      x + cielovaSirka - sirka;
  }

  const posunY =
    y + (cielovaVyska - vyska) / 2;

  pdf.addImage(
    imageData,
    "PNG",
    posunX,
    posunY,
    sirka,
    vyska
  );
}

function zapisKontaktVPate(
  pdf,
  kontaktPdf = {}
) {
  const riadky = [
    {
      text: "Kontakt:",
      tucne: true,
    },
    {
      text: hodnotaText(
        kontaktPdf.meno
      ),
      tucne: false,
    },
    {
      text: kontaktPdf.email
        ? `mail: ${hodnotaText(
            kontaktPdf.email
          )}`
        : "",
      tucne: false,
    },
    {
      text: kontaktPdf.telefon
        ? `tel.: ${hodnotaText(
            kontaktPdf.telefon
          )}`
        : "",
      tucne: false,
    },
    {
      text: kontaktPdf.nbsCislo
        ? `NBS číslo: ${hodnotaText(
            kontaktPdf.nbsCislo
          )}`
        : "",
      tucne: false,
    },
  ].filter((riadok) => riadok.text);

  if (!riadky.length) {
    return;
  }

  const sirkaBloku = 42;

  const x =
    SIRKA_STRANY -
    OKRAJ_X -
    sirkaBloku;

  const spodneY =
    VYSKA_STRANY - 4.8;

  const xDeliacaCiara = x - 3.2;

  const pripraveneRiadky =
    riadky.flatMap((riadok) => {
      pdf.setFont(
        "Inter",
        riadok.tucne
          ? "bold"
          : "normal"
      );

      pdf.setFontSize(8.5);

      return pdf
        .splitTextToSize(
          riadok.text,
          sirkaBloku
        )
        .map((text) => ({
          text,
          tucne: riadok.tucne,
        }));
    });

  let y =
    spodneY -
    (
      pripraveneRiadky.length - 1
    ) *
      3.9;

  const deliacaCiaraHore =
    y - 1.8;

  const deliacaCiaraDole =
    y +
    (
      pripraveneRiadky.length - 1
    ) *
      3.9 +
    0.8;

  pdf.setDrawColor(...FARBA_PATY);
  pdf.setLineWidth(0.45);

  pdf.line(
    xDeliacaCiara,
    deliacaCiaraHore,
    xDeliacaCiara,
    deliacaCiaraDole
  );

  pripraveneRiadky.forEach(
    (riadok) => {
      pdf.setTextColor(
        ...FARBA_PATY
      );

      pdf.setFont(
        "Inter",
        riadok.tucne
          ? "bold"
          : "normal"
      );

      pdf.setFontSize(8.5);
      pdf.text(riadok.text, x, y);
      y += 3.9;
    }
  );
}

function zapisFiremneUdajeVPate(
  pdf
) {
  const x = SIRKA_STRANY / 2;

  const spodneY =
    VYSKA_STRANY - 4.8;

  let y =
    spodneY -
    (
      FIREMNE_UDAJE.length - 1
    ) *
      6.9;

  FIREMNE_UDAJE.forEach(
    (riadok, index) => {
      pdf.setTextColor(
        ...FARBA_PATY
      );

      pdf.setFont(
        "Inter",
        index === 0
          ? "bold"
          : "normal"
      );

      pdf.setFontSize(9);

      pdf.text(riadok, x, y, {
        align: "center",
      });

      y += 3.8;
    }
  );
}

function pridajHlavuAPatu(
  pdf,
  cisloStrany,
  pocetStran,
  kontaktPdf
) {
  pridajObrazokCover(
    pdf,
    horeImg,
    0,
    0,
    SIRKA_STRANY,
    VYSKA_HLAVY
  );

  pridajObrazokCover(
    pdf,
    doleImg,
    0,
    VYSKA_STRANY - VYSKA_PATY,
    SIRKA_STRANY,
    VYSKA_PATY
  );

  zapisKontaktVPate(
    pdf,
    kontaktPdf
  );

  zapisFiremneUdajeVPate(pdf);

  pdf.setTextColor(...FARBA_JEMNA);
  pdf.setFont("Inter", "normal");
  pdf.setFontSize(9);

  pdf.text(
    `Strana ${cisloStrany}/${pocetStran}`,
    SIRKA_STRANY / 2,
    VYSKA_STRANY - 4.8,
    {
      align: "center",
    }
  );
}

export async function vytvorInvesticnyPdf() {
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
    compress: true,
  });

  await nacitajPdfFonty(pdf);

  return pdf;
}

export function vytvorInvestPdfStav(
  kontaktPdf
) {
  return {
    y: INVEST_PDF_START_Y,
    kontaktPdf: kontaktPdf || {},
  };
}

export function novaInvestPdfStrana(
  pdf,
  stav
) {
  pdf.addPage();
  stav.y = INVEST_PDF_START_Y;
}

export function zabezpecInvestPdfMiesto(
  pdf,
  stav,
  potrebnaVyska
) {
  if (
    stav.y + potrebnaVyska <=
    INVEST_PDF_MAX_Y
  ) {
    return;
  }

  novaInvestPdfStrana(pdf, stav);
}

export function zapisInvestPdfNadpis(
  pdf,
  stav,
  text
) {
  zabezpecInvestPdfMiesto(
    pdf,
    stav,
    12
  );

  pdf.setTextColor(
    ...FARBA_NADPIS
  );

  pdf.setFont("Inter", "bold");
  pdf.setFontSize(18);
  pdf.text(text, OKRAJ_X, stav.y);

  stav.y += 10;
}

export function zapisInvestPdfRiadok(
  pdf,
  stav,
  text,
  {
    tucne = false,
    jemne = false,
  } = {}
) {
  zabezpecInvestPdfMiesto(
    pdf,
    stav,
    7
  );

  pdf.setTextColor(
    ...(
      jemne
        ? FARBA_JEMNA
        : FARBA_TEXT
    )
  );

  pdf.setFont(
    "Inter",
    tucne ? "bold" : "normal"
  );

  pdf.setFontSize(10.5);
  pdf.text(text, OKRAJ_X, stav.y);

  stav.y += 6;
}

function zapisTextZarovnanyPodlaOkrajov(
  pdf,
  riadky,
  x,
  y,
  sirka,
  vyskaRiadka
) {
  riadky.forEach(
    (riadok, index) => {
      const obsahRiadka =
        String(
          riadok || ""
        ).trim();

      const slova =
        obsahRiadka
          .split(/\s+/)
          .filter(Boolean);

      const jePoslednyRiadok =
        index ===
        riadky.length - 1;

      const riadokY =
        y +
        index *
          vyskaRiadka;

      if (
        jePoslednyRiadok ||
        slova.length < 2
      ) {
        pdf.text(
          obsahRiadka,
          x,
          riadokY
        );

        return;
      }

      const celkovaSirkaSlov =
        slova.reduce(
          (
            sucet,
            slovo
          ) =>
            sucet +
            pdf.getTextWidth(
              slovo
            ),
          0
        );

      const pocetMedzier =
        slova.length - 1;

      const sirkaMedzery =
        Math.max(
          0,
          (
            sirka -
            celkovaSirkaSlov
          ) /
            pocetMedzier
        );

      let slovoX = x;

      slova.forEach(
        (
          slovo,
          indexSlova
        ) => {
          pdf.text(
            slovo,
            slovoX,
            riadokY
          );

          if (
            indexSlova <
            slova.length - 1
          ) {
            slovoX +=
              pdf.getTextWidth(
                slovo
              ) +
              sirkaMedzery;
          }
        }
      );
    }
  );
}

export function zapisInvestPdfUpozornenie(
  pdf,
  stav,
  text,
  {
    zarovnatNadPatu = false,
  } = {}
) {
  const sirkaTextu =
    INVEST_PDF_SIRKA_OBSAHU - 14;

  pdf.setFont("Inter", "normal");
  pdf.setFontSize(10.5);

  const riadky =
    pdf.splitTextToSize(
      text,
      sirkaTextu
    );

  const vyskaRiadka =
    5.2;

  const potrebnaVyska =
    14 +
    riadky.length *
      vyskaRiadka;

  if (zarovnatNadPatu) {
    const cieloveY =
      INVEST_PDF_MAX_Y -
      potrebnaVyska;

    if (stav.y > cieloveY) {
      novaInvestPdfStrana(
        pdf,
        stav
      );
    }

    stav.y = Math.max(
      stav.y,
      cieloveY
    );
  } else {
    zabezpecInvestPdfMiesto(
      pdf,
      stav,
      potrebnaVyska
    );
  }

  stav.y += 6;

  pdf.setTextColor(
    ...FARBA_NADPIS
  );

  pdf.setFont("Inter", "bold");
  pdf.setFontSize(12);

  pdf.text(
    "Dôležité upozornenie",
    OKRAJ_X,
    stav.y
  );

  stav.y += 7;

  pdf.setTextColor(
    ...FARBA_JEMNA
  );

  pdf.setFont("Inter", "normal");
  pdf.setFontSize(10.5);

  zapisTextZarovnanyPodlaOkrajov(
    pdf,
    riadky,
    OKRAJ_X,
    stav.y,
    sirkaTextu,
    vyskaRiadka
  );

  stav.y +=
    riadky.length *
      vyskaRiadka;
}

export function zapisInvestPdfLinku(
  pdf,
  stav
) {
  pdf.setDrawColor(
    ...FARBA_LINKA
  );

  pdf.setLineWidth(0.3);

  pdf.line(
    OKRAJ_X,
    stav.y,
    SIRKA_STRANY - OKRAJ_X,
    stav.y
  );

  stav.y += 5;
}

export function zapisInvestPdfPrehlad(
  pdf,
  stav,
  prehladInvesticie
) {
  const varianty = Array.isArray(
    prehladInvesticie?.varianty
  )
    ? prehladInvesticie.varianty
    : [];

  const sekcie = Array.isArray(
    prehladInvesticie?.sekcie
  )
    ? prehladInvesticie.sekcie
    : [];

  if (
    !varianty.length ||
    !sekcie.length
  ) {
    return;
  }

  const {
    padding,
    vyskaNadpisu,
    vyskaHlavicky,
    vyskaSekcie,
    vyskaRiadka,
    sirkaPopisuJedenVariant,
    sirkaPopisuDvaVarianty,
  } =
    INVEST_PDF_PREHLAD_ROZLOZENIE;

  const pocetRiadkov =
    sekcie.reduce(
      (sucet, sekcia) =>
        sucet +
        sekcia.riadky.length,
      0
    );

  const vyskaKarty =
    padding * 2 +
    vyskaNadpisu +
    vyskaHlavicky +
    sekcie.length *
      vyskaSekcie +
    pocetRiadkov *
      vyskaRiadka;

  zabezpecInvestPdfMiesto(
    pdf,
    stav,
    vyskaKarty + 5
  );

  const x = OKRAJ_X;
  const y = stav.y;
  const sirka =
    INVEST_PDF_SIRKA_OBSAHU;

  const sirkaPopisu =
    varianty.length === 1
      ? sirkaPopisuJedenVariant
      : sirkaPopisuDvaVarianty;

  const sirkaVarianty =
    sirka -
    padding * 2 -
    sirkaPopisu;

  const sirkaVariantu =
    sirkaVarianty /
    varianty.length;

  let aktualneY =
    y + padding;

  pdf.setFillColor(
    255,
    255,
    255
  );

  pdf.setDrawColor(
    ...FARBA_LINKA
  );

  pdf.setLineWidth(0.35);

  pdf.roundedRect(
    x,
    y,
    sirka,
    vyskaKarty,
    3,
    3,
    "FD"
  );

  pdf.setTextColor(
    ...FARBA_NADPIS
  );

  pdf.setFont(
    "Inter",
    "bold"
  );

  pdf.setFontSize(9.2);

  pdf.text(
    "Prehľad investície",
    x + padding,
    aktualneY + 4.5
  );

  aktualneY +=
    vyskaNadpisu;

  pdf.setFillColor(
    ...FARBA_PREHLAD_HLAVICKA
  );

  pdf.rect(
    x + padding,
    aktualneY,
    sirka - padding * 2,
    vyskaHlavicky,
    "F"
  );

  pdf.setTextColor(
    ...FARBA_TEXT
  );

  pdf.setFont(
    "Inter",
    "bold"
  );

  pdf.setFontSize(7.5);

  varianty.forEach(
    (variant, index) => {
        const hodnotaX =
        x +
        padding +
        sirkaPopisu +
        sirkaVariantu *
            (
            index +
            1
            ) -
        2;

        pdf.text(
        variant.label,
        hodnotaX,
        aktualneY + 4.7,
        {
            align: "right",
        }
        );
    }
    );

  aktualneY +=
    vyskaHlavicky;

  sekcie.forEach(
    (sekcia) => {
      pdf.setFillColor(
        ...FARBA_PREHLAD_SEKCIA
      );

      pdf.rect(
        x + padding,
        aktualneY,
        sirka -
          padding * 2,
        vyskaSekcie,
        "F"
      );

      pdf.setTextColor(
        ...FARBA_NADPIS
      );

      pdf.setFont(
        "Inter",
        "bold"
      );

      pdf.setFontSize(7.6);

      pdf.text(
        sekcia.nazov,
        x + padding + 2,
        aktualneY + 4.2
      );

      aktualneY +=
        vyskaSekcie;

      sekcia.riadky.forEach(
        (riadok) => {
          const popisX =
            x +
            padding +
            2 +
            (
              riadok.odsadenie
                ? 3
                : 0
            );

          pdf.setTextColor(
            ...FARBA_JEMNA
          );

          pdf.setFont(
            "Inter",
            "normal"
          );

          pdf.setFontSize(7.2);

          pdf.text(
            riadok.label,
            popisX,
            aktualneY + 3.7
          );

          riadok.hodnoty.forEach(
            (
              hodnota,
              index
            ) => {
              const hodnotaX =
                x +
                padding +
                sirkaPopisu +
                sirkaVariantu *
                  (
                    index +
                    1
                  ) -
                2;

              pdf.setTextColor(
                ...FARBA_TEXT
              );

              pdf.setFont(
                "Inter",
                "bold"
              );

              pdf.setFontSize(
                7.6
              );

              pdf.text(
                String(hodnota),
                hodnotaX,
                aktualneY +
                  3.7,
                {
                  align:
                    "right",
                  maxWidth:
                    sirkaVariantu -
                    4,
                }
              );
            }
          );

          pdf.setDrawColor(
            ...FARBA_PREHLAD_RIADOK
          );

          pdf.setLineWidth(
            0.15
          );

          pdf.line(
            x + padding,
            aktualneY +
              vyskaRiadka,
            x +
              sirka -
              padding,
            aktualneY +
              vyskaRiadka
          );

          aktualneY +=
            vyskaRiadka;
        }
      );
    }
  );

  stav.y =
    y +
    vyskaKarty +
    5;
}

export function finalizujInvestPdfStrany(
  pdf,
  kontaktPdf
) {
  const pocetStran =
    pdf.getNumberOfPages();

  for (
    let cisloStrany = 1;
    cisloStrany <= pocetStran;
    cisloStrany += 1
  ) {
    pdf.setPage(cisloStrany);

    pridajHlavuAPatu(
      pdf,
      cisloStrany,
      pocetStran,
      kontaktPdf
    );
  }
}

export function bezpecnyNazovInvestPdf(
  nazov
) {
  const cistyNazov = String(
    nazov || "Ponuka_investicie"
  )
    .trim()
    .replace(
      /[\\/:*?"<>|]+/g,
      "-"
    )
    .replace(/\s+/g, "_");

  const nazovSuboru =
    cistyNazov ||
    "Ponuka_investicie";

  return nazovSuboru
    .toLowerCase()
    .endsWith(".pdf")
    ? nazovSuboru
    : `${nazovSuboru}.pdf`;
}